import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#000000a6","font-size":"12px"} }, " 此导出文件需使用密码打开，初始密码为123456。如忘记密码，请点击页面右上角头像选择重置下载密码。 ", -1)
const _hoisted_2 = ["onClick"]

import { ref, toRefs, reactive, onMounted } from "vue";
import dayjs, { Dayjs } from "dayjs";
import type { Rule } from "ant-design-vue/es/form";
import moment from "moment";
import { useRoute } from "vue-router";
import { FormInstance, message } from "ant-design-vue";
import { exportRecordList } from "@/api/pos";
import { getDownloadUrl } from "@/api/home";

export default /*#__PURE__*/_defineComponent({
  __name: 'PosExportRecordModal',
  setup(__props, { expose: __expose }) {

const open = ref<boolean>(false);

const showModal = () => {
  open.value = true;
  getTableData();
};

const handleSubmit = (values: any) => {};
const handleFinishFailed = (errors: any) => {
  console.log(
    "%c [ errors ]-188",
    "font-size:13px; background:pink; color:#bf2c9f;",
    errors
  );
};
__expose({
  showModal,
});
const dataSource = ref<Array<any>>([]);
const loading = ref<boolean>(false);
const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const pageSizeConfig = ref(5);
const totalData = ref(0);
const columns = ref<Array<any>>([
  {
    title: "文件名称",
    dataIndex: "fileName",
    key: "fileName",
  },
  {
    title: "操作人",
    dataIndex: "userName",
    key: "userName",
  },
  {
    title: "操作时间",
    dataIndex: "operationTime",
    key: "operationTime",
  },
  {
    title: "状态",
    dataIndex: "stateZh",
    key: "stateZh",
  },
]);

const getTableData = async (data: any = {}) => {
  loading.value = true;
  data.type = "POS";
  let res: any = await exportRecordList(data);
  if (res.code == 200) {
    loading.value = false;
    dataSource.value = res.data.dataList;
    totalData.value = res.data.total;
    checkFileState(res.data.dataList);
  } else {
    message.error(res.msg);
  }
};

const onChangePage = (pageNum: number, pageSize: number) => {
  let data = {
    pageNum: pageNum,
    pageSize: pageSize,
  };
  pageSizeConfig.value = pageSize;
  currentPage.value = pageNum;
  getTableData(data);
};

const handleDownload = async (record: any) => {
  let params = {
    id: record.attachmentId,
    duration: 60 * 10,
  };
  let res = await getDownloadUrl(params);
  let a = document.createElement("a");
  a.href = res.data;
  a.click();
};

const checkFileState = (list: Array<any>) => {
  list.forEach((e) => {
    if (e.state == "EXPORTING") {
      setTimeout(() => {
        getTableData();
      }, 3000);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
      title: "导出记录",
      width: "800px",
      okText: "确定",
      cancelText: "取消",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_table, {
          dataSource: dataSource.value,
          style: {"margin-top":"4px"},
          columns: columns.value,
          pagination: {
          current: currentPage.value,
          onChange: onChangePage,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          total: totalData.value,
          pageSize: pageSizeConfig.value,
        },
          loading: loading.value
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'fileName' && record.state == 'SUCCESS')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  style: {"color":"#42b983"},
                  onClick: ($event: any) => (handleDownload(record))
                }, _toDisplayString(record.fileName), 9, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "loading"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})